import { FC } from 'react';

import VerificationLogoutPopup from "src/components/popups/components/verification/logoutPopup";
import BoostOddPopup from "src/components/popups/components/boostOddPopup";
import ClearBetslipPopup from "./components/clearBetslipPopup";
import LeaveEditingPopup from './components/leaveEditingPopup';
import SuccessPopup from './components/successPopup';
import CalculatorPopup from './components/calculatorPopup'

export const CLEAR_BETSLIP_POPUP = 'clearBetslip';
export const LEAVE_EDITING_POPUP = 'leaveEditing';
export const VERIFICATION_LOGOUT_POPUP = 'verificationLogoutPopup';
export const BOOSTED_ODD_POPUP = 'boostedOddPopup';
export const SUCCESS_POPUP = 'successPopup';
export const CALCULATOR_POPUP = 'calculatorPopup'

export const popupsMap: { [key: string]: FC<any> } = {
  [CALCULATOR_POPUP]: CalculatorPopup,
  [CLEAR_BETSLIP_POPUP]: ClearBetslipPopup,
  [LEAVE_EDITING_POPUP]: LeaveEditingPopup,
  [VERIFICATION_LOGOUT_POPUP]: VerificationLogoutPopup,
  [BOOSTED_ODD_POPUP]: BoostOddPopup,
  [SUCCESS_POPUP]: SuccessPopup,
}
